<template>
  <div class="layoutWrapper default">
    <Rgpd v-model="displayRgpd" />
    <Popup
      :value="$store.state.login.display"
      @input="$store.dispatch('login/SET_DISPLAY', false)"
    >
      <Login />
    </Popup>
    <Modal
      class="inLayoutIgnoreFontUpscale ignoreFontUpscale"
      :value="$store.state.band_signup.display"
      @input="$store.dispatch('band_signup/SET_DISPLAY', false)"
    >
      <BandSignupInit />
    </Modal>
    <transition mode="in-out" name="fade" class="navbarWrapper">
      <Navindex v-if="display_nav" :class="nav_no_shadow" />
    </transition>
    <DraftPopupSave class="inLayoutIgnoreFontUpscale ignoreFontUpscale" />
    <BandIncomplete :key="$route.fullPath" />
    <SnackbarCenter />
    <intercom_button />
    <BucketPopup
      v-if="BUCKET_INSPECTED_INFLUENCER"
      :influencer="BUCKET_INSPECTED_INFLUENCER"
      class="inLayoutIgnoreFontUpscale ignoreFontUpscale"
      @close="SET_INSPECTED_INFLUENCER(null)"
    />
    <Nuxt :class="{ noHeight: MENU_FULL_SCREEN, ...nav_no_shadow }" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"

import thirdparties from "~/mixins/third_party/load"
import events from "~/mixins/events"
import resize_mixin from "~/mixins/resize"

import Login from "~/components/auth/login"
import BandSignupInit from "~/components/band/signup/init"
import Modal from "~/components/shared/modal"
import Popup from "~/components/shared/popup"
import Rgpd from "~/components/layout/rgpd"
import SnackbarCenter from "~/components/layout/snackbarCenter"
import Navindex from "~/components/nav/index"
import BandIncomplete from "~/components/nav/warnings/bandIncomplete"
import DraftPopupSave from "~/components/draft/popup/save"
import BucketPopup from "~/components/agency/favorites/bucketPopup"

import intercom_button from "~/components/intercom/button"

export default {
  components: {
    BucketPopup,
    Rgpd,
    Login,
    Modal,
    Popup,
    BandSignupInit,
    Navindex,
    BandIncomplete,
    SnackbarCenter,
    intercom_button,
    DraftPopupSave,
  },
  mixins: [...thirdparties, events, resize_mixin],
  data: function () {
    return {
      displayRgpd: false,
      navExcluded: [
        { url: ["/draft/influencers"] },
        { url: ["/influencer/profile", "preview"] },
        { url: ["/draft/", "/track/"], sub: 1024 },
        { url: ["/draft/", "/recap/"], sub: 1024 },
        { url: ["/draft/", "/messages/"], sub: 1024 },
        { url: ["/draft/", "/selection/"], sub: 1024 },
        { url: ["/draft/", "/influencers/"], sub: 1024 },
        { url: ["/draft/", "/favorites/"], sub: 1024 },
      ],
      navNoShadow: [{ url: ["/draft/", "/influencers/"] }],
    }
  },
  mounted: function () {
    this.trigger_page_visit_event()
  },
  computed: {
    display_nav: function () {
      return !this.navExcluded.some((e) => {
        const out = e.url.every((_e) => this.$route.path.includes(_e))

        if (out && typeof e.sub === "number") return this.screenWidth < e.sub
        else return out
      })
    },
    nav_no_shadow: function () {
      return {
        navNoShadow: this.navNoShadow.some((e) => {
          return e.url.every((_e) => this.$route.path.includes(_e))
        }),
      }
    },
    ...mapState({
      MENU_FULL_SCREEN: (state) => state.misc.menu.fullScreen,
      BUCKET_INSPECTED_INFLUENCER: (state) =>
        state.user.favorites.inspectedInfluencer,
    }),
  },
  methods: {
    trigger_page_visit_event: function () {
      if (process.client) {
        this.trackEvent({
          category: "Visit",
          action: "Page Visit",
        })
      }
    },
    pageChange: function () {
      this.trigger_page_visit_event()
    },
    ...mapMutations({
      SET_PREVIOUS_ROUTE: "routing/SET_PREVIOUS",
      SET_INSPECTED_INFLUENCER: "user/favorites/SET_INSPECTED_INFLUENCER",
    }),
  },
  watch: { "$route.path": "pageChange" },
}
</script>

<style scoped>
.noHeight {
  overflow: hidden;
  height: 0px;
}
</style>
